import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PRIVILEGES from '../constants/privileges';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { RBACRoute } from './RBACRoute';

const InternalPurchase = lazy(() => import('../modules/internal-purchase'));

const InternalPurchaseTable = lazy(
  () => import('../modules/internal-purchase/pages/InternalPurchase')
);

const CreateInternalPurchase = lazy(
  () => import('../modules/internal-purchase/pages/createInternalPurchase')
);

const EditInternalPurchase = lazy(
  () => import('../modules/internal-purchase/pages/editInternalPurchase')
);

const InternalPurchaseRoutes = (
  <>
    <Route
      path="purchases/expenses"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <InternalPurchase />
        </Suspense>
      }
    >
      <Route
        path=""
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.EXPENSES_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <InternalPurchaseTable />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path="create"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.EXPENSES_CREATE]}>
            <Suspense fallback={<SkeletonPage />}>
              <CreateInternalPurchase />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.EXPENSES_UPDATE]}>
            <Suspense fallback={<SkeletonPage />}>
              <EditInternalPurchase />
            </Suspense>
          </RBACRoute>
        }
      />
    </Route>
  </>
);

export default InternalPurchaseRoutes;
